// Güven Kepenk — tek iş bilgisi kaynağı (NAP + entity)
// DEĞİŞTİRME KURALI: telefon/adres/e-posta buradan değişir; başka yerde kopya tutma.
// OWNER_INPUT_REQUIRED: gerçek adres, GBP URL, kuruluş tarihi onayı, sosyal profil URL'leri.
export const business = {
  name: 'Güven Kepenk',
  shortName: 'Güven Kepenk',
  legalName: 'OWNER_INPUT_REQUIRED: legal entity (örn. Armahan Group Mimarlık Ltd. Şti. — doğrulanmadan yayınlanmaz)',
  domain: 'guvenkepenk.com.tr',
  url: 'https://www.guvenkepenk.com.tr',
  phone: {
    raw: '+905010817161',
    display: '0501 081 71 61',
  },
  whatsapp: '905010817161',
  email: 'info@guvenkepenk.com.tr',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'İstanbul',
    addressRegion: 'İstanbul',
    addressCountry: 'TR',
  },
  serviceArea: { '@type': 'City', name: 'İstanbul' },
  // OWNER_INPUT_REQUIRED: gerçek kuruluş yılı onaylanana kadar sadece ekip deneyimi vurgusu kullan
  yearsExperience: 20, // ekibin sektör deneyimi (şirket kuruluşu değil)
  socialProfiles: [
    'https://www.facebook.com/guvenkepenk',
    'https://www.instagram.com/guvenkepenk',
    'https://www.google.com/maps/search/G%C3%BCven+Kepenk+%C4%B0stanbul',
  ],
  hours: '7/24',
};

export const whatsappLink = `https://wa.me/${business.whatsapp}`;
